module.exports = __webpack_public_path__ + "img/1.06.thmb.xs.47d1d98b.jpg";